import { on } from '@disy/lib/event-util';

export function setupEllipsis() {
  return on(document.documentElement, 'mouseover', (event) => {
    const element = event.composedPath().find(isEllipsisElement);
    if (element) {
      ellipsis(element);
    }
  });
}

function isEllipsisElement(target: EventTarget): target is HTMLElement {
  return (
    target instanceof HTMLElement &&
    (target.classList.contains('ellipsis') || target.classList.contains('multiline-ellipsis'))
  );
}

/**
 * Put the textContent of an element into its title if necessary.
 *
 * @param element - The element to set the title on
 */
function ellipsis(element: HTMLElement) {
  const hasTitle = element.hasAttribute('title');
  const needsTitle =
    element.matches('.multiline-ellipsis') ?
      element.offsetHeight < element.scrollHeight
    : element.offsetWidth < element.scrollWidth;

  if (!hasTitle && needsTitle && element.textContent) {
    element.title = element.textContent.replaceAll(/(\s{2,}|\n)/g, ' ').trim();
  } else if (hasTitle && !needsTitle) {
    element.removeAttribute('title');
  }
}
